export default "__VITE_ASSET__00f7107a__"